import { render, staticRenderFns } from "./Instituto.vue?vue&type=template&id=5ad4716c&"
import script from "./Instituto.vue?vue&type=script&lang=js&"
export * from "./Instituto.vue?vue&type=script&lang=js&"
import style0 from "./Instituto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports